import React from 'react';
import * as TFF from '@tff/types/TFF';
import BookingCard from './BookingCard';
import { isNewJourneySameAsOriginal } from '../../Utils/isOriginalBookingJourney';

interface BookingCardsProps {
  originalJourneys: TFF.Journey[];
  newBookingJourneys?: TFF.Journey[];
  isRoundTrip: boolean;
  fareDifference?: number;
}

const BookingCards: React.FC<BookingCardsProps> = ({
  originalJourneys,
  newBookingJourneys,
  isRoundTrip,
  fareDifference,
}) => {
  return (
    <div>
      <div className="tff-original-booking">
        <BookingCard journeys={originalJourneys} isOriginalBooking={true} />
      </div>
      {newBookingJourneys && (
        <div className="tff-new-booking">
          <BookingCard
            journeys={newBookingJourneys}
            isOriginalBooking={false}
            fareDifference={fareDifference! < 0 ? 0 : fareDifference}
            isOutboundDifferent={!isNewJourneySameAsOriginal(originalJourneys[0], newBookingJourneys[0])}
            isInboundDifferent={
              isRoundTrip ? !isNewJourneySameAsOriginal(originalJourneys[1], newBookingJourneys[1]) : false
            }
          />
        </div>
      )}
    </div>
  );
};

export default BookingCards;
